import connectionsStore, { DragInfo3, EditorState3, PlaceID3, PlaceStore } from "@mobx/store/connections";
import { EQUIPMENT_TYPE } from "@store/Equipments/actionTypes";
import { Point } from "framer-motion";

export interface BuildinigEditorsState3 {
  initialized: boolean;
  version: string;
  currentKind: EQUIPMENT_TYPE;
  saved: boolean;
  afterKindChange: boolean;
  kinds: { [kind in EQUIPMENT_TYPE]: EditorState3 };
  drags: DragInfo3[];
  isDrag: boolean;
  mousePos?: Point;
  shift?: Point;
}

export const useEditorState3 = <T = EditorState3>(kind: EQUIPMENT_TYPE, placeID?: PlaceID3, f?: (s?: EditorState3, bs?: PlaceStore) => T): T | undefined => {
  const ff = f ?? ((x?: EditorState3) => x as T)
  return placeID
    ? ff(connectionsStore.getPlaceStore(placeID)?.kinds[kind], connectionsStore.getPlaceStore(placeID))
    : undefined
}

